import React from 'react'

import { EsisTag, EsisTagProps } from '../../../components/esis-tag/esis-tag.js'
import { PageTitle, PageTitleProps } from '../../../components/page-title/page-title.js'
import { Separator } from '../../../components/separator/separator.js'
import { renderBlock, ViewAccountBlockProps } from '../account/account.js'

export interface ViewUpgradeProps {
    title: PageTitleProps
    esisTag: EsisTagProps
    notificationBlock?: ViewAccountBlockProps
}

export const ViewUpgrade = (props: ViewUpgradeProps): JSX.Element => {
    return (
        <>
            <PageTitle {...props.title} alwaysButton={true} />
            <Separator variant="large" />
            {props.notificationBlock && renderBlock(props.notificationBlock, 0, false)}
            <Separator variant="large" />
            <EsisTag {...props.esisTag} />
        </>
    )
}
